import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useAuthContext } from "../../../contexts/AuthContext";
import { ComByUserIdQuery, ComByUserIdQueryVariables } from "../../../graphql/API";
import { useQuery } from "@apollo/client";
import { comByUserId } from "./queries";
import { Spinner } from "react-bootstrap";

interface SubscriptionCheckoutProps {
  type: string;
}

const SubscriptionCheckout = ({type}: SubscriptionCheckoutProps) => {
  // AUTH
  const {userId: AuthUserId, user} = useAuthContext();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const types = [
    // { name: '9w&ddq7kda&8lt$h23', unit: 0000, price: t('stripe.starter.price'), title: t('stripe.starter.name'), description: `${t('stripe.starter.description')}<br />${t('stripe.trial.description')}` },
    { name: 'Starter', unit: 1500, price: t('stripe.starter.price'), title: t('stripe.starter.name'), description: `${t('stripe.starter.description')}\n${t('stripe.trial.description')}` },
    { name: 'Essential', unit: 3000, price: t('stripe.essential.price'), title: t('stripe.essential.name'), description: t('stripe.essential.description') },
    { name: 'Plus', unit: 4500, price: t('stripe.plus.price'), title: t('stripe.plus.name'), description: t('stripe.plus.description') }, 
    { name: 'Advanced', unit: 6000, price: t('stripe.advanced.price'), title: t('stripe.advanced.name'), description: t('stripe.advanced.description') },
    { name: 'Pro', unit: 7500, price: t('stripe.pro.price'), title: t('stripe.pro.name'), description: t('stripe.pro.description') },
    { name: 'Business', unit: 12000, price: t('stripe.business.price'), title: t('stripe.business.name'), description: t('stripe.business.description') },
    { name: 'Premium', unit: 15000, price: t('stripe.premium.price'), title: t('stripe.premium.name'), description: t('stripe.premium.description') },
    { name: 'Elite', unit: 20000, price: t('stripe.elite.price'), title: t('stripe.elite.name'), description: t('stripe.elite.description') },
    { name: 'Ultimate', unit: 30000, price: t('stripe.ultimate.price'), title: t('stripe.ultimate.name'), description: t('stripe.ultimate.description') },
    { name: 'Infinity', unit: 45000, price: t('stripe.infinity.price'), title: t('stripe.infinity.name'), description: t('stripe.infinity.description') },
  ];

  const sub = types.find(sub => sub.name.toLowerCase() === type.toLowerCase());

  const {data, loading: loadingCompany, error, refetch, fetchMore} = useQuery
    <ComByUserIdQuery, ComByUserIdQueryVariables>(comByUserId, {variables: {userId: AuthUserId}});

  const company = data?.comByUserId?.items[0];

  if (!company) {
    return (
        <div className="spinnerContainer">
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const handleSubscription = async () => {
    setLoading(true);
    const userLocale = t('stripe.locale');
      const uri = sub.name === "Starter" ? 
        // "http://192.168.60.234:8000/api/stripe/trial/create-subscription-session/"
        "https://schedulum.org/api/stripe/trial/create-subscription-session/"
      :
        // "http://192.168.60.234:8000/api/stripe/create-subscription-session/"
        "https://schedulum.org/api/stripe/create-subscription-session/"
  
      const res = await fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ 
        locale: userLocale,
        title: sub.title,//t('stripe.premium.name'),
        price: sub.unit,
        description: sub.description, //t('billing.subscription') + sub.max + t('billing.workers'),//t('stripe.premium.description'),
        email: user.signInDetails.loginId,
        user_id: AuthUserId,
        com_id: company.comId,
        product_name: sub.name
      }),
    });
    const data = await res.json();
    if (data.url) {
      window.location.href = data.url;  // 🔗 Redirige vers Stripe Checkout
    }
    setLoading(false);
  };

  const trial = sub.description.split('\n');

  return (
    <div style={{marginTop: "100px", textAlign: "center"}}>
      <h2>{sub.title} - {sub.price}</h2>
      { trial[1] ? 
        // <p dangerouslySetInnerHTML={{ __html: sub.description }} />
        <>
          <p>{trial[0]}</p>
          <p>{trial[1]}</p>
        </>
      :
        <p>{sub.description}</p>
      }
      <button onClick={handleSubscription} disabled={loading}>
        {loading ? t('signup.loading') : t('stripe.subscribing')}
      </button>
    </div>
  );
}

export default SubscriptionCheckout;
